const ReadIcon = ({iconColor}) => {
  return (
    <svg
      width="15.99px"
      height="8px"
      viewBox="0 0 18 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.4701 1.9976C12.7131 1.72763 12.6912 1.3118 12.4212 1.06883C12.1513 0.825853 11.7354 0.847738 11.4925 1.11771L7.08325 6.01683L6.44385 5.50531C6.16023 5.27841 5.74638 5.3244 5.51948 5.60802C5.29259 5.89164 5.33857 6.30549 5.62219 6.53238L6.20187 6.99613L5.7393 7.5101C5.44537 7.83668 4.94776 7.87739 4.60467 7.60292L1.98266 5.50531C1.69904 5.27841 1.28519 5.3244 1.05829 5.60802C0.831397 5.89164 0.877381 6.30549 1.161 6.53238L3.78301 8.62999C4.67018 9.33973 5.95692 9.23448 6.71695 8.38999L7.23068 7.81918L8.2442 8.62999C9.13138 9.33973 10.4181 9.23448 11.1781 8.38999L16.9313 1.9976C17.1743 1.72763 17.1524 1.3118 16.8824 1.06883C16.6124 0.825853 16.1966 0.847738 15.9536 1.11771L10.2005 7.5101C9.90657 7.83668 9.40895 7.87739 9.06586 7.60292L8.11206 6.83987L12.4701 1.9976Z"
        fill={iconColor}
        stroke={iconColor}
        stroke-width="0.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default ReadIcon;
